import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Images } from 'lucide-react';
import { galleryImages } from '../data/mock';
import { Link } from 'react-router-dom';

const GallerySlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  // Auto-play slider
  useEffect(() => {
    if (!isAutoPlaying) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % galleryImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const goToPrevious = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => (prev === 0 ? galleryImages.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const goToSlide = (index) => {
    setIsAutoPlaying(false);
    setCurrentIndex(index);
  };

  // Show 3 images at a time on desktop
  const getVisibleImages = () => {
    const images = [];
    for (let i = 0; i < 3; i++) {
      const index = (currentIndex + i) % galleryImages.length;
      images.push({ src: galleryImages[index], index });
    }
    return images;
  };

  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="flex flex-col sm:flex-row items-center justify-between mb-12 gap-6">
          <div className="text-center sm:text-left">
            <span className="text-red-600 font-semibold text-sm uppercase tracking-wider">Galeri</span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mt-3">
              Eğitim Ortamlarımız
            </h2>
            <p className="text-gray-600 text-lg mt-4 max-w-xl">
              Modern ve teknolojik donanımlı çalışma alanlarımızı keşfedin.
            </p>
          </div>
          <Link
            to="/galeri"
            className="group flex items-center gap-3 bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 hover:shadow-xl hover:shadow-red-600/30 hover:-translate-y-1"
          >
            <Images className="w-5 h-5 transition-transform group-hover:scale-110" />
            Tüm Galeri
          </Link>
        </div>

        {/* Slider Container */}
        <div className="relative">
          {/* Navigation Buttons */}
          <button
            onClick={goToPrevious}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 w-12 h-12 bg-white shadow-lg hover:shadow-xl rounded-full flex items-center justify-center transition-all hover:bg-red-50 group"
          >
            <ChevronLeft className="w-6 h-6 text-gray-600 group-hover:text-red-600 transition-colors" />
          </button>
          
          <button
            onClick={goToNext}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 w-12 h-12 bg-white shadow-lg hover:shadow-xl rounded-full flex items-center justify-center transition-all hover:bg-red-50 group"
          >
            <ChevronRight className="w-6 h-6 text-gray-600 group-hover:text-red-600 transition-colors" />
          </button>

          {/* Images Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 overflow-hidden px-4">
            {getVisibleImages().map((image, idx) => (
              <div
                key={`${image.index}-${idx}`}
                className="relative aspect-[4/3] overflow-hidden rounded-2xl group cursor-pointer"
                onClick={() => goToSlide(image.index)}
              >
                <img
                  src={image.src}
                  alt={`Nova Eğitim - ${image.index + 1}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            ))}
          </div>

          {/* Dots Navigation */}
          <div className="flex justify-center gap-2 mt-8">
            {galleryImages.slice(0, 6).map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                  currentIndex === index 
                    ? 'bg-red-600 w-8' 
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GallerySlider;
